export const MARKETSTORE_EXTRA_ATTEMPT = "MARKETSTORE_EXTRA_ATTEMPT";
export const MARKETSTORE_EXTRA_SUCCESS = "MARKETSTORE_EXTRA_SUCCESS";
export const MARKETSTORE_EXTRA_FAILED = "MARKETSTORE_EXTRA_FAILED";

